const isShallowEqual = (obj1, obj2) =>
  Object.keys(obj1).length === Object.keys(obj2).length &&
  Object.keys(obj1).every(key =>
    // eslint-disable-next-line no-prototype-builtins
    obj2.hasOwnProperty(key) && obj1[key] === obj2[key]
  )

export default isShallowEqual
